import {Component, EventEmitter, Input, Output} from '@angular/core';
import {GentelellaModalContainerComponent} from './modal-container.component';

@Component({
    selector: 'tfl-gentelella-modal-header',
    template: `
        <div class="modal-header">
            <button *ngIf="showDismiss" type="button" class="close" aria-label="Dismiss" (click)="dismiss()">
                <span aria-hidden="true">&times;</span>
            </button>
            <ng-content></ng-content>
        </div>
    `
})
export class GentelellaModalHeaderComponent {
    @Input() showDismiss: boolean = false;
    @Output() dismissHandler: EventEmitter<any> = new EventEmitter(true);

    dismiss() {
        this.dismissHandler.emit();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/modal/modal-header.component.ts